import { getCurrentBasic } from './core/ProgramService'

/**
 *
 * @description 爆料台 - 首页 - 浏览
 */
export async function reportRevealView() {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'REVEAL',
            businessVer: 1,
            pageName: '爆料台首页',
            pageUrl: window.location.href,
            view: 1,
        }),
    )
}

/**
 *
 * @description 爆料台 - 栏目 - 浏览
 */
export async function reportRevealProgramView(params: {
    /** 爆料台栏目id */
    revealProgramId: string

    /** 爆料台栏目title */
    revealProgramTitle: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign({}, await getCurrentBasic(), {
            business: 'REVEAL',
            businessVer: 1,
            pageName: '爆料台栏目页',
            pageUrl: window.location.href,

            ref1: params.revealProgramId,
            ref1Title: params.revealProgramTitle,
            ref1Name: '爆料台栏目',

            view: 1,
        }),
    )
}

/**
 *
 * @description 爆料台 - 话题 - 浏览
 */
export async function reportRevealScheduleView(params: {
    /** 爆料台栏目id */
    revealProgramId: string

    /** 爆料台栏目title */
    revealProgramTitle: string

    /** 话题id */
    revealScheduleId: string

    /** 话题title */
    revealScheduleTitle: string

    /** 话题第一个节点 */
    revealScheduleNodeModel: {
        id: string
        name: string
    }
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign({}, await getCurrentBasic(), {
            business: 'REVEAL',
            businessVer: 1,
            pageName: '爆料台话题页',
            pageUrl: window.location.href,

            ref1Name: '爆料台栏目',
            ref1: params.revealProgramId,
            ref1Title: params.revealProgramTitle,

            ref2Name: '爆料台栏目排期',
            ref2: params.revealScheduleId,
            ref2Title: params.revealScheduleTitle,

            ref3Name: '爆料台节点',
            ref3: params.revealScheduleNodeModel.id,
            ref3Title: params.revealScheduleNodeModel.name,

            view: 1,
        }),
    )
}
